export default __webpack_public_path__ + "static/media/dark-logo.3b3e93f7.svg";